const formatBoolean = (value) => {
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  return value || '';
};

export const createCustomerSchema = () => {
  return {
    title: 'Customer Details',
    summary: {
      title: 'Details',
      fields: [
        { key: 'businessName', label: 'Business Name' },
        { key: 'pointOfcontact', label: 'Point of Contact' },
        { key: 'address', label: 'Address' },
        { key: 'contactNumber', label: 'Contact Number' },
        { key: 'contactEmail', label: 'Contact Email' },
        { key: 'paperless', label: 'Paperless', format: (v) => formatBoolean(v) },
        { key: 'cod', label: 'Cash on Delivery', format: (v) => formatBoolean(v) },
      ],
    },
    sections: [
      {
        title: 'Notes',
        fields: [{ key: 'notes', label: 'Notes' }],
      },
    ],
  };
};
